import { getContext, track } from '../core';

const MILESTONES = [25, 50, 75, 90] as const;

export function initScrollTracking(): void {
  const fired = new Set<number>();
  let blogTimerStarted = false;
  let ticking = false;

  const getScrollPercent = (): number => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return 100;
    return Math.round((scrollTop / docHeight) * 100);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const pct = getScrollPercent();
      const ctx = getContext();

      for (const milestone of MILESTONES) {
        if (pct >= milestone && !fired.has(milestone)) {
          fired.add(milestone);
          track('scroll_milestone', {
            scroll_percentage: milestone,
            page_type: ctx.analytics_page_type,
            page_name: ctx.page_name || ctx.page_title.split(' | ')[0].trim(),
          });

          // Start blog deep read timer at 75%
          if (milestone === 75 && ctx.page_type === 'post' && !blogTimerStarted) {
            blogTimerStarted = true;
            setTimeout(() => {
              track('blog_deep_read', {
                article_title: ctx.article_title || ctx.page_title,
                blog_category: ctx.blog_category,
              });
            }, 60_000);
          }
        }
      }

      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}
